export function getRequestHeaders() {
  const token = localStorage.getItem('tradersToken');
  const currentGameId = localStorage.getItem('current-game-id');
  return {
    'content-type': 'application/json',
    'Accept': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    ...('X-Game-User-id' ? { 'X-Game-User-id': currentGameId } : {})
  };
}

export const REQUEST_HEADERS = {
	'content-type': 'application/json',
	'Accept': 'application/json',
};
